import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  listHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gridGap: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  documentItems: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: 260,
  },
}))

export default styles
